var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3547",
    "data-name": "Rectangle 3547",
    width: 5.044,
    height: 8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(2.198 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3548",
    "data-name": "Rectangle 3548",
    width: 10,
    height: 10,
    transform: "translate(-2.198 -1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553",
    transform: "translate(0.302 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9028",
    "data-name": "Path 9028",
    d: "M4.739,3.261,1.783.306A1.045,1.045,0,0,0,.306,1.783L2.522,4,.306,6.215A1.045,1.045,0,0,0,1.783,7.694L4.739,4.738a1.046,1.046,0,0,0,0-1.477",
    transform: "translate(0 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.13fa411d.svg";
export { ForwardRef as ReactComponent };